import styled from '@emotion/styled'

/**
 * GyeonggiMap 스타일.
 *
 * 캔버스 크기는 필터(전체/북부/남부)에 따라 동적이라 inline style로 주입:
 *  - max-width: canvas.width × GYEONGGI_RENDER_SCALE (Figma 새 디자인 비율 적용)
 *  - aspect-ratio: canvas.width / canvas.height
 *
 * 라벨 폰트: Figma 스펙(13px / SemiBold / line-height 18) 고정 — 가독성 우선.
 */

/** 외부 wrapper — 지도 영역 컨테이너 (필터 칩은 page.tsx로 끌어올림) */
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

/**
 * MapStage — 시별 SVG들이 비율 좌표로 배치되는 무대 영역.
 *
 * 이름 주의: HTML `<canvas>` 태그가 아니라 `<div>`다.
 *
 * 반응형 전략:
 *  - width: 100% / max-width: 동적(필터별 캔버스 너비 × render scale, inline) → 작은 화면 자동 축소
 *  - aspect-ratio: 동적(필터별 비율, inline) → height 자동
 *  - 안의 SVG/라벨은 모두 % 좌표라 같이 스케일
 */
export const MapStage = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  flex-shrink: 0;
`

/**
 * 시별 SVG path — 시각만, hit area 없음 (라벨 클릭만 트리거).
 * width %로 자동 스케일. height는 img 자체 viewBox 비율로 자동 결정.
 *
 * z-index 1: 라벨 button(z-index 2) 아래에 두어 라벨 텍스트가 path 위로 보이게.
 * transition: 라벨 button:active 시 sibling selector로 brightness 적용 시 자연스러운 페이드.
 */
export const RegionImage = styled.img`
  position: absolute;
  display: block;
  pointer-events: none;
  user-select: none;
  z-index: 1;
  transition: filter 0.08s ease-out;
`

/**
 * 라벨 hit area — 텍스트 주변에 padding을 둬서 모바일 터치 영역 확보.
 * transform: translate(-50%, -50%) 으로 라벨 좌표가 텍스트 '중심'을 가리킴.
 *
 * Pressed 효과 (Figma 18000:197334 반영):
 *  - 라벨: opacity 살짝 낮춰 클릭 피드백
 *  - 인접 path(다음 형제 img): filter brightness 로 어두워짐 → enabled→pressed 색상 근사
 *  - DOM 구조 의존: GyeonggiMap/IncheonMap에서 region 단위로 [button, img] 순서로 sibling 배치
 */
export const RegionLabelHitArea = styled.button`
  position: absolute;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 0;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  z-index: 2;

  &:active {
    opacity: 0.7;
  }

  &:active + img {
    filter: brightness(0.92);
  }
`

/**
 * 라벨 폰트 — 캔버스에 따라 분기.
 * - data-canvas='full' (전체): 10px — 시 17개 빽빽해서 작게
 * - data-canvas='north' | 'south' (북/남): 13px — 시 적어 여유 있어 가독성 우선
 */
export const RegionLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: #1b1c1d;
  white-space: nowrap;
  pointer-events: none;

  &[data-canvas='full'] {
    font-size: 10px;
  }
`
